import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import { generateRangeArray } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class Paginator extends ApplicationComponent {
  isButtonDisabled(comparedToPage) {
    return this.props.page === comparedToPage
  }

  arrayOfPageNumbers() {
    // ex. [1,4,5,6,12]
    const low = Math.max(1, this.props.page - 1)
    const high = Math.min(this.numberOfPages(), this.props.page + 2)

    // Create a range array using the generateRangeArray helper function
    const range = generateRangeArray(low, high)

    // Combine arrays and remove duplicates
    const combined = [1].concat(range).concat([this.numberOfPages()])
    return [...new Set(combined)]
  }

  numberOfPages() {
    return Math.max(this.props.numberOfPages, 1)
  }

  renderPaginationItems() {
    let lastPage = 0
    return this.arrayOfPageNumbers().map((page) => {
      const html = (
        <div key={page} className="flex items-center justify-center">
          {lastPage + 1 !== page ? <div className="bs-mx-2">...</div> : ""}
          <button
            type="button"
            className={`btn ${
              page === this.props.page ? "btn-primary" : "btn-tertiary"
            }`}
            onClick={() => this.props.goToPage(page)}
          >
            {page}
          </button>
        </div>
      )
      lastPage = page
      return html
    })
  }

  render() {
    return (
      <div className="flex items-center justify-center">
        <button
          type="button"
          className={classNames("btn btn-ghost", {
            disabled: this.isButtonDisabled(1),
          })}
          onClick={() =>
            !this.isButtonDisabled(1) &&
            this.props.goToPage(this.props.page - 1)
          }
          aria-label="decrease page number"
        >
          <i className="fa-kit fa-chevron-left text-muted" />
        </button>
        {this.renderPaginationItems()}
        <button
          type="button"
          className={classNames("btn btn-ghost", {
            disabled: this.isButtonDisabled(this.numberOfPages()),
          })}
          onClick={() =>
            !this.isButtonDisabled(this.numberOfPages()) &&
            this.props.goToPage(this.props.page + 1)
          }
          aria-label="increase page number"
        >
          <i className="fa-kit fa-chevron-right text-muted" />
        </button>
      </div>
    )
  }
}

Paginator.propTypes = {
  page: PropTypes.number.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired,
}

export default Paginator
